import productStockLookupApi from "../../api/inventory/productStockLookupApi";

const ProductStockLookupService = {
  /**
   * 🔍 Lista (paginada) productos con stock por sucursal, con término de
   * búsqueda opcional — sin término se listan todos, paginados.
   * GET /api/inventory/stock/lookup?branchId=&term=&page=&size=
   */
  search: async (
    branchId: number,
    term: string,
    page = 0,
    size = 10
  ) => {
    const termParam = term && term.trim() ? `&term=${encodeURIComponent(term)}` : "";
    const response = await productStockLookupApi.fetchCustom(
      `?branchId=${branchId}${termParam}&page=${page}&size=${size}`
    );

    return response.data;
  },
};

export default ProductStockLookupService;
